@switch (value) {
  @case (0) {
    <span class="badge rounded-pill text-bg-success" style="font-size: 11px">{{ displayName }}</span>
  }
  @case (1) {
    <span class="badge rounded-pill bg-light text-secondary border border-secondary" style="font-size: 11px">{{
      displayName
    }}</span>
  }
  @case (2) {
    <span class="badge rounded-pill text-bg-warning" style="font-size: 11px">{{ displayName }}</span>
  }
  @case (3) {
    <span class="badge rounded-pill bg-light text-success border border-success" style="font-size: 11px">{{
      displayName
    }}</span>
  }
  @case (4) {
    <span class="badge rounded-pill bg-light text-secondary border border-secondary" style="font-size: 11px">{{
      displayName
    }}</span>
  }
  @default {
    <span class="badge rounded-pill text-bg-light" style="font-size: 11px">{{ displayName }}</span>
  }
}
